import ServicePageLayout from '../../components/feature/ServicePageLayout';

export default function PerfectFitBlindsPage() {
  return (
    <ServicePageLayout
      blindType="Perfect Fit Blinds"
      heroTitle="Perfect Fit Blinds Northampton"
      heroSubtitle="No-Drill Blinds That Fit Perfectly Into Your uPVC Windows"
      introText="Perfect Fit blinds are the ideal solution for uPVC windows and doors. These innovative blinds fit neatly into a frame that clips directly onto your window without any drilling or screws, making them perfect for conservatories, tilt and turn windows, and rental properties."
      heroImage="https://public.readdy.ai/ai/img_res/129916dc2f6b82112919a62fd6c841bd.jpg"
      features={[
        { icon: 'ri-tools-line', title: 'No Drilling Required', desc: 'Clips directly onto uPVC frames without damaging your windows' },
        { icon: 'ri-layout-grid-line', title: 'Neat & Tidy Fit', desc: 'Sits perfectly within the window frame for a sleek finish' },
        { icon: 'ri-sun-line', title: 'Ideal for Conservatories', desc: 'Perfect solution for conservatory windows and roof panels' },
        { icon: 'ri-door-open-line', title: 'Tilt & Turn Compatible', desc: 'Moves with the window when opened, no obstruction' },
        { icon: 'ri-home-gear-line', title: 'Rental Property Friendly', desc: 'No permanent fixtures means perfect for rented homes' },
        { icon: 'ri-palette-line', title: 'Multiple Styles Available', desc: 'Choose from roller, pleated, venetian and cellular options' },
      ]}
      pricePerBlind="£119"
      wholeHousePrice="£899"
      benefits={[
        { icon: 'ri-check-line', text: 'No drilling required' },
        { icon: 'ri-check-line', text: 'Ideal for uPVC windows' },
        { icon: 'ri-check-line', text: 'Perfect for conservatories' },
        { icon: 'ri-check-line', text: 'Rental property friendly' },
        { icon: 'ri-check-line', text: 'Professional installation' },
      ]}
      faqs={[
        {
          question: 'How do Perfect Fit blinds attach without drilling?',
          answer: 'Perfect Fit blinds use a clever frame system that clips directly onto the beading of your uPVC window. The frame holds the blind securely in place without any need for drilling holes or using screws.'
        },
        {
          question: 'Will Perfect Fit blinds work on my windows?',
          answer: 'Perfect Fit blinds are designed specifically for uPVC windows and doors. They work on most standard uPVC frames, including tilt and turn windows, conservatory windows, and patio doors. Our team will measure and confirm compatibility during your free consultation.'
        },
        {
          question: 'Can I use Perfect Fit blinds in a conservatory?',
          answer: 'Absolutely! Perfect Fit blinds are one of the most popular choices for conservatories. They provide excellent light control and insulation without drilling into your conservatory frames, and they look incredibly neat and tidy.'
        },
        {
          question: 'What blind styles are available in Perfect Fit?',
          answer: 'We offer Perfect Fit frames with several blind styles including roller blinds, pleated blinds, venetian blinds, and cellular/honeycomb blinds. Each style offers different benefits for light control, insulation, and appearance.'
        },
        {
          question: 'Are Perfect Fit blinds suitable for rental properties?',
          answer: 'Yes! Perfect Fit blinds are ideal for rental properties because they don\'t require any drilling or permanent fixtures. They can be easily removed without leaving any marks or damage, making them perfect for tenants and landlords alike.'
        },
        {
          question: 'Do Perfect Fit blinds provide good insulation?',
          answer: 'Yes, especially when you choose cellular or honeycomb Perfect Fit blinds. The frame creates a sealed unit against the window, and the blind fabric provides an additional insulation layer, helping to keep your home warmer in winter and cooler in summer.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  The Smart Choice for Modern uPVC Windows in Northampton
                </h3>
                <p className="text-gray-700 mb-6">
                  Perfect Fit blinds have revolutionized window coverings for modern homes across Northampton. Whether you have a beautiful conservatory that needs stylish sun protection, tilt and turn windows that require a flexible solution, or you're renting and can't drill into the frames, Perfect Fit blinds offer the perfect answer. Our expert team will ensure your blinds are measured and fitted perfectly for a flawless, integrated finish that enhances your windows rather than covering them up.
                </p>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=perfect%20fit%20blinds%20installed%20in%20uPVC%20conservatory%20windows%20neat%20integrated%20look%20bright%20airy%20space%20no%20drilling%20contemporary%20home%20no%20people%20professional%20photography&width=800&height=600&seq=perfectfit-add-001&orientation=landscape"
                  alt="Perfect Fit Blinds in Conservatory"
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
}